export const LOAD_ORDERS = 'load_orders';
export const ORDERS_LOADED = 'set_loaded_orders';
export const ORDERS_FAILED = 'orders_sync_error';

export const LOAD_ORDER = 'load_order';
export const ORDER_LOADED = 'set_loaded_order';
export const ORDER_FAILED = 'order_sync_error';

export const LOAD_ORDER_DETAILS = 'load_order_details';
export const ORDER_DETAILS_LOADED = 'order_details_loaded';
export const ORDER_DETAILS_FAILED = 'order_details_failed';

export const SAVE_ORDER = 'save_order';
export const ORDER_SAVED = 'order_saved';
export const SAVE_ORDER_ERROR = 'save_order_error';

export const RESET_ORDERS = 'reset_orders';
